import ins1 from "../assets/images/institutions/Abbott_icon.png";
import ins2 from "../assets/images/institutions/Roche_icon.png";
import ins3 from "../assets/images/institutions/Sanofi_logo.png";
import ins4 from "../assets/images/institutions/ckz.png";
import ins5 from "../assets/images/institutions/abbvie_logo.png";
import ins6 from "../assets/images/institutions/biocodex_logo.png";
import ins7 from "../assets/images/institutions/instituProfile.svg";

// labo
import labo1 from "../assets/images/institutions/Sanofi_logo.png";
import labo2 from "../assets/images/institutions/Roche_logo.png";
import labo3 from "../assets/images/institutions/biocodex_logo.png";
import labo4 from "../assets/images/institutions/Polymedic_logo.png";
import labo5 from "../assets/images/institutions/hikma_logo.png";
import labo6 from "../assets/images/institutions/devapharmaceutique_logo.png";
import labo7 from "../assets/images/institutions/cipla_logo.png";
import labo8 from "../assets/images/institutions/cyclopharma_logo.png";
import labo9 from "../assets/images/institutions/logosobrus.webp";
import labo10 from "../assets/images/institutions/laprophangreen.svg";

export const institutionImages = {
  1: ins1,
  2: ins2,
  3: ins3,
  4: ins4,
  5: ins5,
  6: ins6,
  7: ins7,
};
export const labosImages = {
  1: labo1,
  2: labo2,
  3: labo3,
  4: labo4,
  5: labo5,
  6: labo6,
  7: labo7,
  8: labo8,
  9: labo9,
  10: labo10,
};

const getInstitutionImagePath = (id) => institutionImages[id];

export const institutions = [
  {
    // CHU Example
    id: 1,
    avatar: getInstitutionImagePath(1),
    logo: "CK",
    acronym: "CHU",
    type: "CHU",
    featured: true,
    verified: true,
    premium: true,
    name: "CHU Cheikh Khalifa",
    description: "Centre Hospitalier Universitaire spécialisé en cardiologie",
    overview: {
      description:
        "Le Centre Hospitalier Universitaire Cheikh Khalifa est un établissement de santé de pointe, offrant des soins médicaux spécialisés et une formation médicale d'excellence.",
      vision:
        "Devenir un centre d'excellence en matière de soins de santé au Maroc et en Afrique.",
      mission:
        "Fournir des soins de santé de qualité, former les futurs professionnels de santé et conduire des recherches médicales innovantes.",
    },
    country: "Morocco",
    city: "Casablanca",
    category: "hospital",
    specialties: ["Cardiologie", "Neurologie", "Chirurgie", "Oncologie"],
    certifications: ["ISO 9001", "JCI Accreditation"],
    stats: {
      bedsCount: 450,
      staffCount: 1200,
      annualPatients: 50000,
      surgeries: 15000,
    },
    followers: 2500,
    following: 280,
    followerTags: ["M", "D", "P"],
    contact: {
      email: "contact@chu-khalifa.ma",
      phone: "+212 520-XXX-XXX",
      fax: "+212 520-XXX-XXX",
      website: "www.chu-khalifa.ma",
      address: "Route nationale, Casablanca",
      coordinates: {
        lat: 33.5731,
        lng: -7.5898,
      },
    },
    socialMedia: {
      linkedin: "chu-khalifa",
      twitter: "@CHUKhalifa",
      facebook: "CHUKhalifaOfficiel",
    },
    modules: [
      {
        id: 1,
        title: "Programme de formation continue",
        description:
          "Formation médicale spécialisée pour les professionnels de santé",
        date: "2024-02-15",
        type: "Formation",
      },
      {
        id: 2,
        title: "Recherche en cardiologie",
        description:
          "Nouvelles approches dans le traitement des maladies cardiaques",
        date: "2024-03-01",
        type: "Recherche",
      },
    ],
    news: [
      {
        id: 1,
        title: "Inauguration du nouveau service de neurochirurgie",
        content:
          "Le CHU Cheikh Khalifa a inauguré son nouveau service de neurochirurgie équipé des dernières technologies médicales.",
        date: "2024-01-10",
        image: null,
      },
      {
        id: 2,
        title: "Partenariat international",
        content:
          "Signature d'un accord de collaboration avec des hôpitaux européens pour l'échange d'expertise.",
        date: "2024-02-20",
        image: null,
      },
    ],
    opinions: [
      {
        id: 1,
        expert: "Dr. Mohammed Alami",
        title: "L'importance de la formation continue en médecine",
        content:
          "Dans un monde médical en constante évolution, la formation continue est essentielle pour maintenir un niveau de soins optimal.",
        date: "2024-01-15",
        rating: 4.8,
      },
      {
        id: 2,
        expert: "Pr. Fatima Zohra Ben Ali",
        title: "Les avancées en cardiologie interventionnelle",
        content:
          "Les nouvelles techniques de cardiologie interventionnelle permettent des traitements moins invasifs et plus efficaces.",
        date: "2024-02-01",
        rating: 4.9,
      },
    ],
    achievements: [
      {
        year: 2023,
        title: "Centre d'excellence en cardiologie",
        description:
          "Reconnaissance internationale pour l'excellence des soins cardiaques",
      },
      {
        year: 2024,
        title: "Certification ISO 9001",
        description: "Obtention de la certification pour la qualité des soins",
      },
    ],
    partnerships: [
      {
        partner: "Faculté de Médecine de Casablanca",
        type: "Académique",
        description: "Formation des étudiants en médecine",
      },
      {
        partner: "Hôpital Universitaire de Paris",
        type: "International",
        description: "Échange de compétences et recherche",
      },
    ],
  },
  {
    // CLINIQUE Example
    id: 2,
    avatar: getInstitutionImagePath(2),
    logo: "CL",
    acronym: "CLP",
    name: "Clinique La Paix",
    description: "Clinique privée spécialisée en chirurgie et soins intensifs",
    type: "CLINIQUE",
    featured: true,
    verified: true,
    overview: {
      description:
        "Clinique moderne offrant des soins personnalisés de haute qualité",
      vision: "Être la référence en matière de soins privés au Maroc",
      mission:
        "Offrir des soins d'excellence dans un environnement confortable",
    },
    country: "Morocco",
    city: "Rabat",
    category: "clinic",
    specialties: ["Chirurgie", "Maternité", "Urgences"],
    certifications: ["ISO 9001"],
    stats: {
      bedsCount: 120,
      staffCount: 300,
      annualPatients: 15000,
      surgeries: 5000,
    },
    followers: 1800,
    following: 150,
    followerTags: ["C", "S", "P"],
    contact: {
      email: "contact@clinique-lapaix.ma",
      phone: "+212 537-XXX-XXX",
      website: "www.clinique-lapaix.ma",
      address: "Avenue Hassan II, Rabat",
      coordinates: {
        lat: 34.0209,
        lng: -6.8416,
      },
    },
    socialMedia: {
      linkedin: "clinique-lapaix",
      facebook: "CliniqueLaPaixOfficiel",
    },
    modules: [
      {
        id: 1,
        title: "Service de maternité premium",
        description: "Suivi personnalisé des futures mamans",
        date: "2024-03-01",
        type: "Service",
      },
    ],
    news: [
      {
        id: 1,
        title: "Nouveau bloc opératoire",
        content:
          "Installation d'équipements chirurgicaux de dernière génération",
        date: "2024-02-01",
        image: null,
      },
    ],
    opinions: [
      {
        id: 1,
        expert: "Dr. Sara Mansouri",
        title: "Excellence en chirurgie",
        content:
          "Notre équipe chirurgicale utilise les techniques les plus avancées",
        date: "2024-01-20",
        rating: 4.7,
      },
    ],
  },
  {
    // LABORATOIRE Example
    id: 3,
    avatar: getInstitutionImagePath(3),
    logo: "LB",
    acronym: "LBM",
    type: "LABORATOIRE",
    verified: true,
    premium: true,
    name: "Laboratoire BioMed",
    medications: [
      {
        id: 1,
        name: "Metformine Biomed",
        description: "Traitement du diabète de type 2",
        status: "Disponible",
        category: "Diabète",
        form: "Comprimé",
        price: "45 MAD",
        availability: true,
        details: {
          composition: "Metformine chlorhydrate",
          dosage: "500mg",
          presentation: "Boîte de 30 comprimés",
        },
      },
      {
        id: 2,
        name: "Amoxicilline BM",
        description: "Antibiotique à large spectre",
        status: "Disponible",
        category: "Antibiotique",
        form: "Gélule",
        price: "35 MAD",
        availability: true,
        details: {
          composition: "Amoxicilline trihydratée",
          dosage: "500mg",
          presentation: "Boîte de 12 gélules",
        },
      },
      {
        id: 3,
        name: "Paracétamol BioM",
        description: "Antalgique et antipyrétique",
        status: "Disponible",
        category: "Antalgique",
        form: "Comprimé",
        price: "15 MAD",
        availability: true,
        details: {
          composition: "Paracétamol",
          dosage: "1000mg",
          presentation: "Boîte de 20 comprimés",
        },
      },
    ],
    description: "Laboratoire d'analyses médicales de pointe",
    overview: {
      description: "Laboratoire moderne d'analyses médicales et de recherche",
      vision: "Innovation en diagnostic médical",
      mission: "Résultats précis et rapides pour meilleurs soins",
    },
    country: "Morocco",
    city: "Rabat",
    category: "laboratory",
    specialties: ["Analyses biologiques", "Génétique", "Microbiologie"],
    certifications: ["ISO 15189", "COFRAC"],
    stats: {
      dailyTests: 1000,
      staffCount: 80,
      annualPatients: 50000,
    },
    followers: 2000,
    following: 100,
    followerTags: ["L", "B", "R"],
    contact: {
      email: "contact@biomed-lab.ma",
      phone: "+212 537-XXX-XXX",
      website: "www.biomed-lab.ma",
      address: "Avenue Mohammed V, Rabat",
      coordinates: {
        lat: 34.0209,
        lng: -6.8416,
      },
    },
    socialMedia: {
      linkedin: "biomed-laboratoire",
      facebook: "BioMedLaboratoire",
    },
    modules: [
      {
        id: 1,
        title: "Tests COVID-19",
        description: "Service de dépistage rapide",
        date: "2024-01-01",
        type: "Service",
      },
    ],
    news: [
      {
        id: 1,
        title: "Nouveau service de génétique",
        content: "Lancement des tests génétiques de nouvelle génération",
        date: "2024-02-15",
        image: null,
      },
    ],
  },
  {
    // PHARMACIE Example
    id: 4,
    avatar: getInstitutionImagePath(4),
    logo: "PH",
    acronym: "PHC",
    type: "PHARMACIE",
    verified: true,
    name: "Pharmacie Centrale",
    description: "Pharmacie moderne avec service 24/7",
    overview: {
      description: "Pharmacie complète avec service conseil personnalisé",
      vision: "Accessibilité et conseil pharmaceutique de qualité",
      mission: "Service pharmaceutique complet et conseils experts",
    },
    country: "Morocco",
    city: "Marrakech",
    category: "pharmacy",
    specialties: ["Médicaments", "Parapharmacie", "Orthopédie"],
    certifications: ["ISO 9001"],
    stats: {
      dailyCustomers: 300,
      staffCount: 12,
      stockItems: 5000,
    },
    followers: 900,
    following: 50,
    followerTags: ["P", "M", "S"],
    contact: {
      email: "contact@pharmacie-centrale.ma",
      phone: "+212 524-XXX-XXX",
      address: "Place Jamaâ El Fna, Marrakech",
      coordinates: {
        lat: 31.6295,
        lng: -7.9811,
      },
    },
    socialMedia: {
      facebook: "PharmacieCentraleMarrakech",
    },
    modules: [
      {
        id: 1,
        title: "Service de garde",
        description: "Disponibilité 24/7",
        date: "2024-01-01",
        type: "Service",
      },
    ],
  },
  {
    // CENTRE MEDICAL Example
    id: 5,
    avatar: getInstitutionImagePath(5),
    logo: "CM",
    acronym: "CMD",
    type: "CENTRE MEDICAL",
    verified: true,
    name: "Centre Médical Dakhla",
    description: "Centre médical multidisciplinaire",
    overview: {
      description: "Centre de consultations et soins ambulatoires",
      vision: "Soins de proximité accessibles et qualitatifs",
      mission: "Offrir des soins de première ligne efficaces",
    },
    country: "Morocco",
    city: "Dakhla",
    category: "medical_center",
    specialties: ["Médecine générale", "Pédiatrie", "Gynécologie"],
    certifications: ["ISO 9001"],
    stats: {
      consultationRooms: 15,
      staffCount: 30,
      annualConsultations: 20000,
    },
    followers: 1200,
    following: 80,
    followerTags: ["C", "M", "D"],
    contact: {
      email: "contact@cm-dakhla.ma",
      phone: "+212 528-XXX-XXX",
      website: "www.cm-dakhla.ma",
      address: "Boulevard Mohammed V, Dakhla",
      coordinates: {
        lat: 23.7141,
        lng: -15.9368,
      },
    },
    socialMedia: {
      facebook: "CentreMedicalDakhla",
      instagram: "cmdakhla",
    },
    modules: [
      {
        id: 1,
        title: "Consultations spécialisées",
        description: "Service de consultations sur rendez-vous",
        date: "2024-02-01",
        type: "Service",
      },
    ],
  },
  {
    // HOPITAL Example
    id: 6,
    avatar: getInstitutionImagePath(6),
    logo: "HP",
    acronym: "HPR",
    type: "HOPITAL",
    verified: true,
    name: "Hôpital Provincial",
    description: "Hôpital public de référence régionale",
    overview: {
      description: "Établissement hospitalier public polyvalent",
      vision: "Soins de qualité accessibles à tous",
      mission: "Service public de santé efficient",
    },
    country: "Morocco",
    city: "Tanger",
    category: "hospital",
    specialties: ["Urgences", "Chirurgie", "Médecine interne"],
    certifications: ["Accréditation nationale"],
    stats: {
      bedsCount: 300,
      staffCount: 600,
      annualPatients: 40000,
    },
    followers: 1500,
    following: 100,
    followerTags: ["H", "M", "U"],
    contact: {
      email: "contact@hopital-provincial.ma",
      phone: "+212 539-XXX-XXX",
      address: "Quartier administratif, Tanger",
      coordinates: {
        lat: 35.7595,
        lng: -5.834,
      },
    },
    socialMedia: {
      facebook: "HopitalProvincialTanger",
    },
    modules: [
      {
        id: 1,
        title: "Service des urgences",
        description: "Prise en charge des urgences médicales 24/7",
        date: "2024-01-01",
        type: "Service",
      },
    ],
    news: [
      {
        id: 1,
        title: "Rénovation du service de pédiatrie",
        content: "Modernisation complète du service de pédiatrie",
        date: "2024-02-10",
        image: null,
      },
    ],
  },
  {
    // Additional CHU Example
    id: 7,
    avatar: getInstitutionImagePath(1),
    logo: "IB",
    acronym: "IBN",
    type: "CHU",
    featured: true,
    verified: true,
    name: "CHU Ibn Sina",
    description: "Centre Hospitalier Universitaire de référence nationale",
    overview: {
      description: "Plus grand complexe hospitalier universitaire du Maroc",
      vision: "Leadership en soins tertiaires et recherche médicale",
      mission: "Excellence en soins, formation et recherche",
    },
    country: "Morocco",
    city: "Rabat",
    category: "hospital",
    specialties: [
      "Neurochirurgie",
      "Transplantation",
      "Oncologie",
      "Pédiatrie",
    ],
    certifications: ["ISO 9001", "JCI Accreditation"],
    stats: {
      bedsCount: 1000,
      staffCount: 3000,
      annualPatients: 150000,
      surgeries: 30000,
    },
    followers: 3500,
    following: 200,
    followerTags: ["U", "R", "T"],
    contact: {
      email: "contact@chu-ibnsina.ma",
      phone: "+212 537-XXX-XXX",
      website: "www.chu-ibnsina.ma",
      address: "Avenue Hassan II, Rabat",
      coordinates: {
        lat: 34.0209,
        lng: -6.8416,
      },
    },
    modules: [
      {
        id: 1,
        title: "Centre de transplantation",
        description: "Programme national de transplantation d'organes",
        date: "2024-03-01",
        type: "Service",
      },
    ],
  },
  {
    // Additional CLINIQUE Example
    id: 8,
    avatar: getInstitutionImagePath(2),
    logo: "CS",
    acronym: "CSP",
    type: "CLINIQUE",
    verified: true,
    premium: true,
    name: "Clinique Spécialisée",
    description: "Clinique spécialisée en chirurgie cardiaque",
    overview: {
      description: "Centre d'excellence en chirurgie cardiaque",
      vision: "Innovation en chirurgie cardiovasculaire",
      mission: "Soins cardiaques de pointe",
    },
    country: "Morocco",
    city: "Casablanca",
    category: "clinic",
    specialties: ["Chirurgie cardiaque", "Cardiologie interventionnelle"],
    certifications: ["ISO 9001", "Accréditation internationale"],
    stats: {
      bedsCount: 80,
      staffCount: 150,
      annualSurgeries: 1200,
    },
    followers: 2000,
    contact: {
      email: "contact@clinique-specialisee.ma",
      phone: "+212 522-XXX-XXX",
      website: "www.clinique-specialisee.ma",
      address: "Quartier Gauthier, Casablanca",
    },
  },
  {
    // Additional LABORATOIRE Example
    id: 9,
    avatar: getInstitutionImagePath(3),
    logo: "LG",
    acronym: "LGN",
    type: "LABORATOIRE",
    verified: true,
    name: "Laboratoire de Génétique",
    medications: [
      {
        id: 1,
        name: "Insuline GénéBio",
        description: "Traitement du diabète",
        status: "Disponible",
        category: "Diabète",
        form: "Solution injectable",
        price: "250 MAD",
        availability: true,
        details: {
          composition: "Insuline humaine recombinante",
          dosage: "100 UI/ml",
          presentation: "Flacon de 10ml",
        },
      },
      {
        id: 2,
        name: "Oméprazole GL",
        description: "Inhibiteur de la pompe à protons",
        status: "Disponible",
        category: "Gastro-entérologie",
        form: "Gélule gastro-résistante",
        price: "80 MAD",
        availability: true,
        details: {
          composition: "Oméprazole",
          dosage: "20mg",
          presentation: "Boîte de 28 gélules",
        },
      },
      {
        id: 3,
        name: "Amlodipine GenLab",
        description: "Antihypertenseur",
        status: "Disponible",
        category: "Cardiologie",
        form: "Comprimé",
        price: "95 MAD",
        availability: true,
        details: {
          composition: "Amlodipine bésilate",
          dosage: "5mg",
          presentation: "Boîte de 30 comprimés",
        },
      },
      {
        id: 4,
        name: "Biotine Forte",
        description: "Complément vitaminique",
        status: "Disponible",
        category: "Complément alimentaire",
        form: "Comprimé",
        price: "120 MAD",
        availability: true,
        details: {
          composition: "Biotine pure",
          dosage: "5mg",
          presentation: "Boîte de 60 comprimés",
        },
      },
    ],
    description: "Laboratoire spécialisé en tests génétiques",
    overview: {
      description: "Centre d'excellence en diagnostic génétique",
      vision: "Leader en diagnostic génétique au Maroc",
      mission: "Diagnostic précis pour médecine personnalisée",
    },
    country: "Morocco",
    city: "Casablanca",
    specialties: ["Génétique médicale", "Tests prénataux", "Oncogénétique"],
    stats: {
      dailyTests: 200,
      staffCount: 40,
    },
    followers: 1500,
    contact: {
      email: "contact@labo-genetique.ma",
      phone: "+212 522-XXX-XXX",
      website: "www.labo-genetique.ma",
    },
  },
  {
    // Additional PHARMACIE Example
    id: 10,
    avatar: getInstitutionImagePath(4),
    logo: "P24",
    acronym: "PH24",
    type: "PHARMACIE",
    verified: true,
    name: "Pharmacie 24/24",
    description: "Pharmacie de garde permanente",
    overview: {
      description: "Service pharmaceutique continu",
      vision: "Accessibilité permanente aux médicaments",
      mission: "Service pharmaceutique 24/7",
    },
    country: "Morocco",
    city: "Fès",
    specialties: ["Médicaments", "Parapharmacie", "Matériel médical"],
    stats: {
      dailyCustomers: 500,
      staffCount: 15,
    },
    followers: 800,
    contact: {
      email: "contact@pharmacie24.ma",
      phone: "+212 535-XXX-XXX",
      address: "Centre-ville, Fès",
    },
  },
];
